// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-project-project-slider----slider-module---wrapper---YKthv","imageWrapper":"src-components-project-project-slider----slider-module---imageWrapper---1Av6W","navWrapper":"src-components-project-project-slider----slider-module---navWrapper---1Wz2A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-slider/slider.module.css
// module id = 534
// module chunks = 140935043865547